import React from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../../../components/Icon";

const Control = ({
  className,
  offer,
  selectedFile,
  hasNewFile,
  hasExistingFile,
  onFileRemove,
  onFileDownload
}) => {
  
  const actions = [];
  
  if (hasNewFile) {
    // Actions pour un nouveau fichier sélectionné
    actions.push({
      icon: "close",
      title: "Supprimer le fichier",
      action: onFileRemove,
      className: styles.remove
    });
  } else if (hasExistingFile) {
    // Actions pour un fichier existant
    actions.push({
      icon: "download",
      title: "Télécharger le fichier",
      action: onFileDownload,
      className: styles.download
    });
  }

  if (actions.length === 0) return null;

  return (
    <div className={cn(styles.control, className)}>
      {actions.map((action, index) => (
        <button 
          className={cn(styles.button, action.className)} 
          key={index} 
          onClick={action.action} 
          disabled={action.disabled}
          title={action.title}
          type="button"
        >
          <Icon name={action.icon} size="16" />
        </button>
      ))}
    </div>
  );
};

export default Control;
